import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { collection, onSnapshot, query, where } from "firebase/firestore";
import type { AppDispatch, RootState } from "../store";

interface ChatState {
    unreadCount: number;
    listening: boolean;
}

const initialState: ChatState = {
    unreadCount: 0,
    listening: false,
};

const chatSlice = createSlice({
    name: "chat",
    initialState,
    reducers: {
        setUnreadCount(state, action: PayloadAction<number>) {
            state.unreadCount = action.payload;
        },
        setListening(state, action: PayloadAction<boolean>) {
            state.listening = action.payload;
        },
        resetChatState(state) {
            state.unreadCount = 0;
            state.listening = false;
        },
    },
});

export const { setUnreadCount, setListening, resetChatState } = chatSlice.actions;
export default chatSlice.reducer;


let unsubscribe: (() => void) | null = null;

export const startChatRealtime = (db: any) => {
    return (dispatch: AppDispatch, getState: () => RootState) => {
        const state = getState();

        if (state.chat.listening) return;

        const influencerId = state.influencer.influencer?.uuid;
        if (!db || !influencerId) return;

        dispatch(setListening(true));

        const q = query(
            collection(db, "entityChatRooms", influencerId, "rooms"),
            where("unreadCount", ">", 0)
        );

        unsubscribe = onSnapshot(q, (snapshot) => {
            dispatch(setUnreadCount(snapshot.size));
        });
    };
};

export const stopChatRealtime = () => {
    return (dispatch: AppDispatch) => {
        if (unsubscribe) {
            unsubscribe();
            unsubscribe = null;
        }

        dispatch(resetChatState());
    };
};
